import { Sentry } from '@/lib/logs';

import { setAnalyticsConsent } from './hooks/PostHogAnalytics';

const handleCookieConsent = () => {
  if (window.Cookiebot?.consent.statistics) {
    setAnalyticsConsent(true);
    Sentry.init();
  } else {
    setAnalyticsConsent(false);
  }
};

// for users who already accepted cookies, we check against stored cookies
// prevents the need to sign out, clear cookies, sign in again
window.addEventListener('CookiebotOnLoad', handleCookieConsent, false);

window.addEventListener('CookiebotOnAccept', handleCookieConsent, false);

// stop capturing if the user withdraws consent during the session
window.addEventListener('CookiebotOnDecline', handleCookieConsent, false);

// cookiebot loads before this bundle, so "CookiebotOnLoad" may have fired before the listeners above
// were registered: apply the stored consent of returning visitors right away
if (window.Cookiebot?.hasResponse) {
  handleCookieConsent();
}
